"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectileVfxStepArgs = void 0;
const uuid_1 = require("uuid");
class ProjectileVfxStepArgs {
    constructor(startAt, endAt, type, pathType = "line", delay = 0) {
        this.startAt = startAt;
        this.endAt = endAt;
        this.type = type;
        this.pathType = pathType;
        this.delay = delay;
        this.__typeName = "Projectile";
        this.id = (0, uuid_1.v4)();
    }
}
exports.ProjectileVfxStepArgs = ProjectileVfxStepArgs;
